import { normalizeProductTypeName, ProductTypeError } from './product-type-form';

export function normalizePackageTypeName(value: any): string {
  return normalizeProductTypeName(value);
}

export function normalizePackageTypeStatus(value: any): 1 | 2 {
  if (value !== 1 && value !== 2) {
    throw new ProductTypeError('validation', 'Selecciona un estado válido.');
  }
  return value;
}

export function packageTypeChanged(name: any, status: any, originalName: any,
  originalStatus: any): boolean {
  return normalizePackageTypeName(name) !== normalizePackageTypeName(originalName) ||
    normalizePackageTypeStatus(status) !== normalizePackageTypeStatus(originalStatus);
}



// WEBPACK FOOTER //
// ./src/utils/package-type-form.ts